import React, { useContext, useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  StyleSheet,
  TouchableOpacity,
  Platform,
  ScrollView,
  Alert,
} from "react-native";
import { AppContext } from "../../AppContext";
import { Colors, Fonts } from "../styles/styles";
import imageMap from "../db/imageMap";
import ProfileImage from "./ProfileImage";
import { Purchases } from "react-native-purchases";
import { RevenueCatProvider } from "../../RevenueCatContext";
import { useRevenueCat } from "../../RevenueCatContext";
import { Linking } from "react-native";
import * as Haptic from 'expo-haptics';

const translations = {
  ESP: {
    trocaliaPro: "Trocalia PRO",
    benefits: [
      "Hazte mecenas de la comunidad",
      "Destaca tus ofertas y gana visibilidad",
      "Busca qué demandan los usuarios",
      "Descubre quién visita tu perfil",
      "Chats ilimitados con usuarios",
      "Ofertas ilimitadas para publicar",
      
    ],
    bePro: "Quiero ser PRO",
    priceAnnualPeriod: "/año",
    priceMonthlyPeriod: "/mensuales",
    priceannualios: "/cada año (auto-renovable)",
    pricemonthlyios: "/cada mes (auto-renovable)",
    or: "o",
    close: "Cerrar",
    save: "Ahorra",
    popupBlockerWarning:
      "Si el proceso de pago no se abre, asegúrate de permitir ventanas emergentes en Safari. Configuración > Safari > Bloquear ventanas emergentes.",
    errorcheckout:
      "Error al iniciar el proceso de pago: verifique su conexión a internet y vuelva a intentarlo.",
    termsAndConditions: "Términos y Condiciones",
    termsAndConditionsEULA: "Términos de uso (EULA)",
    privacyPolicy: "Política de Privacidad",
    support: "Soporte",
    yasoypro:
      "Si previamante has adquirido Trocalia PRO, puedes restaurar tus compras aquí.",
    restaurar: "Restaurar Compras",
    nombreanual: "Trocalia Pro Anual",
    nombremes: "Trocalia Pro Mensual",
    offeringsError: "No disponible",
    offeringsErrorMessage:
      "En este momento no se puede realizar esta acción, pruebe más tarde o escríbanos a sat@trocalia.net.",
  
  },
  CAT: {
    trocaliaPro: "Trocalia PRO",
    benefits: [
      "Sigues mecenes de la comunitat",
      "Destaca les teves ofertes",
      "Busca què demanden els usuaris",
      "Descobreix qui visita el teu perfil",
      "Xats il·limitats amb usuaris",
      "Ofertes il·limitades per publicar",
      
    ],
    bePro: "Vull ser PRO",
    priceAnnualPeriod: "/any",
    priceMonthlyPeriod: "/mensuals",
    priceannualios: "/cada any (auto-renovable)",
    pricemonthlyios: "/cada mes (auto-renovable)",
    or: "o",
    close: "Tancar",
    save: "Estalvi",
    popupBlockerWarning:
      "Si el procés de pagament no s'obre, assegura't de permetre finestres emergents a Safari. Configuració > Safari > Bloquejar finestres emergents.",
    errorcheckout:
      "Error en iniciar el procés de pagament: verifiqui la seva connexió a internet i torni-ho a intentar.",
    termsAndConditions: "Termes i Condicions",
    termsAndConditionsEULA: "Termes d'ús (EULA)",
    privacyPolicy: "Política de Privacitat",
    support: "Suport",
    yasoypro:
      "Si prèviament has adquirit Trocalia PRO, pots restaurar les teves compres aquí.",
    restaurar: "Restaurar Compres",
    restoreCompleted: "Restauració completada",
    nombreanual: "Trocalia Pro Anual",
    nombremes: "Trocalia Pro Mensual",
    offeringsError: "No disponible",
    offeringsErrorMessage:
      "En aquest moment no es pot realitzar aquesta acció, provi-ho més tard o escrigui'ns a sat@trocalia.net.",
  },
  ENG: {
    trocaliaPro: "Trocalia PRO",
    benefits: [
      "Be a patron of the community",
      "Stand out in your community",
      "Search what users demand",
      "Discover who visits your profile",
      "Unlimited chats with users",
      "Unlimited offers to post",
      
    ],
    bePro: "I want to be PRO",
    priceAnnualPeriod: "/year",
    priceMonthlyPeriod: "/monthly",
    priceannualios: "/every year (auto-renewable)",
    pricemonthlyios: "/every month (auto-renewable)",
    or: "or",
    close: "Close",
    save: "Save",
    popupBlockerWarning:
      "If the payment process doesn't open, make sure to allow pop-ups in Safari. Settings > Safari > Block Pop-ups.",
    errorcheckout:
      "Error starting the payment process: check your internet connection and try again.",
    termsAndConditions: "Terms and Conditions",
    termsAndConditionsEULA: "End User License Agreement (EULA)",
    privacyPolicy: "Privacy Policy",
    support: "Support",
    yasoypro:
      "If you have previously purchased Trocalia PRO, you can restore your purchases here.",
    restaurar: "Restore Purchases",
    nombreanual: "Trocalia Pro Annual",
    nombremes: "Trocalia Pro Monthly",
    offeringsError: "Not Available",
    offeringsErrorMessage:
      "This action cannot be performed at the moment. Please try again later or contact us at sat@trocalia.net.",
  },
};

const iconsForBenefits = [187, 391, 51, 240, 233];
const Pro = ({ closeModal }) => {
  const { isReady, offerings, purchaseSubscription } = useRevenueCat();
  const { language, serverAddress, token } = useContext(AppContext);
  const t = translations[language];
  const [planType, setPlanType] = useState("annual"); // Estado inicial
  const [showIOSMessage, setShowIOSMessage] = useState(false);

  // Cálculo del ahorro
  const [monthlyPrice, setMonthlyPrice] = useState("5.99 €");
  const [annualPrice, setAnnualPrice] = useState("39.99 €");
  const [savings, setSavings] = useState("");
  const { restorePurchases } = useRevenueCat();
  let annualTitleStyle =
    planType === "annual"
      ? styles.selectedSubscriptionTitle
      : styles.subscriptionTitle;
  let monthlyTitleStyle =
    planType === "monthly"
      ? styles.selectedSubscriptionTitle
      : styles.subscriptionTitle;

  // Verifica si la plataforma es iOS y ajusta las traducciones
  if (Platform.OS === "ios") {
    pricePeriodAnnual = t.priceannualios;
    pricePeriodMonthly = t.pricemonthlyios;
  }

  useEffect(() => {
    if (isReady && offerings) {
      const monthlyOffering = offerings.monthly;
      const annualOffering = offerings.annual;

      if (monthlyOffering && annualOffering) {
        const monthlyPriceString = `${monthlyOffering.product.priceString} ${monthlyOffering.product.currencyCode}`;
        const annualPriceString = `${annualOffering.product.priceString} ${annualOffering.product.currencyCode}`;
        setMonthlyPrice(monthlyPriceString);
        setAnnualPrice(annualPriceString);

        // Calcula el ahorro
        const monthlyPriceValue = monthlyOffering.product.price;
        const annualPriceValue = annualOffering.product.price;
        const calculatedSavings = Math.round(
          100 - (annualPriceValue / (monthlyPriceValue * 12)) * 100
        );
        setSavings(`${calculatedSavings}`);
      }
    } else {
      // Valores por defecto para Android y web
      const defaultSavings = Math.round(100 - (39.99 / (5.99 * 12)) * 100);
      setSavings(`${defaultSavings}`);
    }
  }, [isReady, offerings]);

  // Detecta el sistema operativo del dispositivo
  const detectOS = () => {
    if (typeof navigator !== "undefined") {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
        ? "iOS"
        : "other";
    }
    return "other";
  };

  const openLink = (url) => {
    Linking.canOpenURL(url).then((supported) => {
      if (supported) {
        Linking.openURL(url);
      } else {
        //console.log(`Don't know how to open this URL: ${url}`);
      }
    });
  };

  const initiateCheckout = async () => {
    if (!offerings) {
      Alert.alert(t.offeringsError, t.offeringsErrorMessage);
    return;
  }
    // La detección del sistema operativo permanece igual
    const os = detectOS();

    // Diferenciar el flujo según la plataforma
    if (Platform.OS === "web") {
      // Flujo para la web, se mantiene intacto
      if (os === "iOS") {
        setShowIOSMessage(true); // Mostrar mensaje para iOS en web
      } else {
        setShowIOSMessage(false);
      }
      try {
        const response = await fetch(
          `${serverAddress}/create-checkout-session`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ planType }),
          }
        );
        const { url } = await response.json();
        Linking.openURL(url);
      } catch (error) {
        alert(t.errorcheckout);
        //console.error(error);
      }
    } else if (isReady) {
      // Manejo para iOS y Android
      const packageToPurchase =
        planType === "annual" ? offerings.annual : offerings.monthly;

      if (packageToPurchase) {
        try {
          // Realiza la compra
          await purchaseSubscription(packageToPurchase);

          // Si la compra es exitosa, cierra el modal
          closeModal(); // Asumiendo que closeModal cierra efectivamente el modal
        } catch (error) {
          Alert.alert(
            "Error",
            "No se encontró el paquete de suscripción deseado."
          );
          //console.error("Error al realizar la compra:", error);
        }
      } else {
        Alert.alert(
          "Error",
          "No se encontró el paquete de suscripción deseado."
        );
      }
    }
  };

  return (
    <ScrollView style={styles.scrollViewStyle}>
      <View
        style={styles.container}
        onStartShouldSetResponder={() => true}
        onResponderTerminationRequest={() => false}
      >
        <View style={styles.header}>
          <Image
            source={require("../img/icons/trocalia2.png")}
            style={styles.trocaliaIcon}
          />
          <Text style={styles.pro}>PRO</Text>
          <ProfileImage style={styles.profileImageStyle} />
          <TouchableOpacity onPress={closeModal} style={styles.closeButton}>
            <Image
              style={styles.closeIcon}
              source={require("../img/icons/block.png")}
            />
          </TouchableOpacity>
        </View>
        <View style={styles.content}>
          {t.benefits.map((benefit, index) => (
            <View key={index} style={styles.benefitContainer}>
              <Text
                style={
                  benefit.includes("Hazte mecenas de la comunidad") ||
                  benefit.includes("Sigues mecenes de la comunitat") ||
                  benefit.includes("Be a patron of the community")
                    ? styles.semiboldText
                    : Fonts.poppinsRegular16
                }
              >
                {benefit}
              </Text>
              <Image
                style={styles.benefitIcon}
                source={imageMap[iconsForBenefits[index]]}
              />
            </View>
          ))}
        </View>

        <View style={styles.priceContainer}>
          {/* Opción de precio anual con "auto-renovable" en línea aparte para iOS */}
          <TouchableOpacity
            style={[
              styles.priceOption,
              planType === "annual" && styles.selectedPrice,
            ]}
            onPress={async () => {
              if (Platform.OS !== 'web') {
                // Añadir la respuesta háptica al pulsar el botón de precio
                await Haptic.impactAsync(Haptic.ImpactFeedbackStyle.Heavy);
              }
              setPlanType("annual");
            }}
          >
            {Platform.OS === "ios" && (
              <Text style={annualTitleStyle}> {t.nombreanual}</Text>
            )}
            <View style={{ alignItems: "center" }}>
              <Text
                style={
                  planType === "annual"
                    ? styles.selectedTextPrice
                    : styles.textPrice
                }
              >
                {`${annualPrice}`}
              </Text>
              <Text
                style={
                  planType === "annual"
                    ? styles.selectedTextPeriod
                    : styles.textPeriod
                }
              >
                {Platform.OS === "ios"
                  ? t.priceannualios.split(" (")[0]
                  : t.priceAnnualPeriod}
              </Text>
              {Platform.OS === "ios" && (
                <Text
                  style={
                    planType === "annual"
                      ? styles.selectedAutoRenewable
                      : styles.autoRenewable
                  }
                >
                  {"(auto-renovable)"}
                </Text>
              )}
              {planType === "annual" && (
                <View style={styles.savingsBadge}>
                  <Text
                    style={styles.savingsText}
                  >{`${t.save} ${savings}%`}</Text>
                </View>
              )}
            </View>
          </TouchableOpacity>

          <View style={styles.separator2}></View>

          {/* Opción de precio mensual con "auto-renovable" en línea aparte para iOS */}
          <TouchableOpacity
            style={[
              styles.priceOption,
              planType === "monthly" && styles.selectedPrice,
            ]}
            onPress={async () => {
              if (Platform.OS !== 'web') {
                // Añadir la respuesta háptica al pulsar el botón de precio
                await Haptic.impactAsync(Haptic.ImpactFeedbackStyle.Heavy);
              }
              setPlanType("monthly");
            }}
          >
            {Platform.OS === "ios" && (
              <Text style={monthlyTitleStyle}>{t.nombremes}</Text>
            )}
            <View style={{ alignItems: "center" }}>
              <Text
                style={
                  planType === "monthly"
                    ? styles.selectedTextPrice
                    : styles.textPrice
                }
              >
                {`${monthlyPrice}`}
              </Text>
              <Text
                style={
                  planType === "monthly"
                    ? styles.selectedTextPeriod
                    : styles.textPeriod
                }
              >
                {Platform.OS === "ios"
                  ? t.pricemonthlyios.split(" (")[0]
                  : t.priceMonthlyPeriod}
              </Text>
              {Platform.OS === "ios" && (
                <Text
                  style={
                    planType === "monthly"
                      ? styles.selectedAutoRenewable
                      : styles.autoRenewable
                  }
                >
                  {"(auto-renovable)"}
                </Text>
              )}
            </View>
          </TouchableOpacity>
        </View>

        <TouchableOpacity style={styles.proButton} onPress={initiateCheckout}>
          <Text style={styles.proButtonText}>{t.bePro}</Text>
        </TouchableOpacity>

        <View style={styles.linksContainer}>
          <TouchableOpacity
            onPress={() =>
              openLink(
                Platform.OS === "ios"
                  ? "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
                  : "https://trocalia.net/termes"
              )
            }
          >
            <Text style={styles.linkText}>
              {Platform.OS === "ios"
                ? t.termsAndConditionsEULA
                : t.termsAndConditions}
            </Text>
          </TouchableOpacity>
          <Text style={styles.separator}>|</Text>
          <TouchableOpacity
            onPress={() => openLink("https://trocalia.net/privacitat")}
          >
            <Text style={styles.linkText}>{t.privacyPolicy}</Text>
          </TouchableOpacity>
        </View>
        {Platform.OS === "ios" && (
          <>
            <Text style={styles.restoreInfoText}>{t.yasoypro}</Text>
            <TouchableOpacity
              style={styles.restoreButton}
              onPress={restorePurchases}
            >
              <Text style={styles.restoreButtonText}>{t.restaurar}</Text>
            </TouchableOpacity>
          </>
        )}

        {showIOSMessage && (
          <Text style={styles.iosMessageStyle}>{t.popupBlockerWarning}</Text>
        )}
      </View>

      <View style={styles.bottomSpacer} />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
    justifyContent: "flex-start",
    alignItems: "center",
  },
  header: {
    alignItems: "center",
    paddingHorizontal: 20,
    paddingTop: Platform.OS === "web" ? 14 : Platform.OS === "ios" ? 70 : 30, 
  },
  closeButton: {
    position: "absolute",
    right: -80,
    top: Platform.OS === "web" ? 22 : Platform.OS === "ios" ? 55 : 28,
    zIndex: 1,
  },
  closeIcon: {
    width: 30,
    height: 30,
  },
  content: {
    marginTop: 10,
    paddingHorizontal: 0,
    marginBottom: 10,
  },
  benefitContainer: {
    alignItems: "center", // Centra el texto y el icono
    marginBottom: 6,
  },
  benefitIcon: {
    width: 15,
    height: 15,
    marginTop: 5, // Espacio entre el texto y el icono
  },
  proButton: {
    backgroundColor: Colors.primary,
    paddingVertical: 12,
    paddingHorizontal: 25,
    borderRadius: 25, // Un borde más redondeado para que destaque
    marginTop: 20, // Ajusta el margen superior según sea necesario
    // shadowColor: "#000", // Estas propiedades de sombra añaden profundidad
    // shadowOffset: {
    //   width: 0,
    //   height: 2,
    // },
    // shadowOpacity: 0.25,
    // shadowRadius: 3.84,
    // elevation: 5,
  },
  proButtonText: {
    ...Fonts.poppinsSemiBold16,
    color: Colors.white,
  },
  priceContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 0,
    marginBottom: 26,
  },
  priceOption: {
    paddingVertical: 15,
    paddingHorizontal: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.grayMedium,
    marginHorizontal: 5,
    marginTop: 0,
  },
  selectedPrice: {
    backgroundColor: Colors.primary,
    borderColor: Colors.primary,
  },
  profileImageStyle: {
    borderWidth: 3,
    borderColor: Colors.secondary,
    marginTop: 20,
    marginBottom: 20,
  },
  trocaliaIcon: {
    width: 150,
    height: 50,
    resizeMode: "contain",
  },
  savingsBadge: {
    flexDirection: "row",
    height: 20,
    width: "auto",
    position: "absolute",
    top: Platform.OS === "ios" ? -50 : -25,
    right: -18,
    backgroundColor: Colors.secondary,
    padding: 2,
    borderRadius: 4,
  },
  savingsText: {
    color: Colors.white,
    fontSize: 12,
  },
  pro: {
    ...Fonts.poppinsSemiBold16,
    color: Colors.secondary,
    position: "absolute",
    top: Platform.OS === "web" ? 40 : Platform.OS === "ios" ? 95 : 54,
    right: -20,
  },
  scrollViewStyle: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  extraSpace: {
    height: 90, // Puedes ajustar este valor según tus necesidades
  },
  text: {
    ...Fonts.poppinsRegular14,
    color: Colors.grayDark,
  },
  selectedText: {
    ...Fonts.poppinsMedium16,
    color: Colors.white,
  },
  semiboldText: {
    ...Fonts.poppinsSemiBold16,
    color: Colors.grayDark,
  },
  textPrice: {
    fontSize: 18,
    fontWeight: "bold",
    color: Colors.grayDark, // Ajusta según tu paleta de colores
  },
  selectedTextPrice: {
    fontSize: 18,
    fontWeight: "bold",
    color: Colors.white, // Ajusta para cuando está seleccionado
  },
  textPeriod: {
    fontSize: 14,
    color: Colors.grayDark, // Ajusta según tu paleta de colores
  },
  selectedTextPeriod: {
    fontSize: Platform.OS === "ios" ? 16 : 14,
    fontWeight: "bold",
    color: Colors.white, // Ajusta para cuando está seleccionado
  },
  separator: {
    height: 40, // Altura de la barra, ajusta según sea necesario
    width: 2, // Grosor de la barra, ajusta según sea necesario
    backgroundColor: Colors.grayMedium, // Color de la barra, ajusta según tu paleta de colores
    marginHorizontal: 10, // Espacio a los lados de la barra, ajusta según sea necesario
  },
  iosMessageStyle: {
    marginTop: 10,
    color: "red", // Por ejemplo, o cualquier estilo que prefieras
    textAlign: "center",
    paddingHorizontal: 20,
  },
  linksContainer: {
    flexDirection: "row", // Coloca los enlaces en una fila
    justifyContent: "center", // Centra los enlaces horizontalmente
    flexWrap: "wrap", // Asegura que los enlaces se envuelvan si no caben en la pantalla
    marginTop: 20, // Ajusta según sea necesario
    marginBottom: 10, // Asegura un espacio antes del bottomSpacer
  },
  linkText: {
    color: Colors.primary,
    textDecorationLine: "underline", // Subraya los enlaces para claridad
    marginHorizontal: 5, // Espacio entre los enlaces y los separadores
    marginVertical: 10, // Espacio vertical alrededor de los enlaces
    fontSize: 16, // Ajusta el tamaño del texto para mejorar la legibilidad
  },
  separator: {
    color: Colors.primary, // Asegúrate de que el separador tenga el mismo color que los enlaces
    paddingHorizontal: 10, // Espacio alrededor de los separadores
    marginVertical: 10, // Espacio vertical alrededor de los separadores
    fontSize: 16, // Alinea el tamaño del separador con el de los enlaces
  },
  separator2: {
    height: 40, // Ajusta si es necesario
    width: 2,
    backgroundColor: Colors.grayMedium,
    alignSelf: "center",
    marginHorizontal: 6, // Aumenta el margen si es necesario para mayor visibilidad
  },
  bottomSpacer: {
    height: 30, // Ajusta este valor para asegurar suficiente espacio para hacer scroll
  },
  restoreInfoText: {
    marginVertical: 10,
    textAlign: "center",
    color: Colors.grayDark,
    paddingHorizontal: 20, // Ajustar según el diseño de tu app
  },
  restoreButton: {
    marginVertical: 20, // Ajusta según sea necesario
    backgroundColor: "white", // Interior blanco
    borderRadius: 20, // Bordes redondeados
    padding: 10,
    paddingHorizontal: 20,
    alignSelf: "center",
    borderWidth: 2, // Grosor del borde
    borderColor: Colors.primary, // Borde del color principal
  },
  restoreButtonText: {
    color: Colors.primary, // Texto del color principal
    textAlign: "center",
  },
  autoRenewable: {
    fontSize: 14, // Ajusta el tamaño del texto como prefieras
    color: Colors.grayDark, // Color por defecto
    marginTop: 4, // Ajusta según demanda
  },
  selectedAutoRenewable: {
    fontSize: 14, // Mantén el mismo tamaño del texto
    color: Colors.white, // Color para cuando está seleccionado
    marginTop: 4, // Ajusta según demanda
  },
  subscriptionTitle: {
    color: Colors.grayDark,
    textAlign: "center",
    padding: 0, // Ajusta según demanda
    marginBottom: 6, // Ajusta según demanda
  },

  selectedSubscriptionTitle: {
    color: Colors.white,

    textAlign: "center",
    padding: 0, // Ajusta según demanda
    marginBottom: 6, // Ajusta según demanda
  },
});

export default Pro;
